import { render, staticRenderFns } from "./PolicyInstruments.vue?vue&type=template&id=080ce64c&scoped=true"
import script from "./PolicyInstruments.vue?vue&type=script&lang=js"
export * from "./PolicyInstruments.vue?vue&type=script&lang=js"
import style0 from "./PolicyInstruments.vue?vue&type=style&index=0&id=080ce64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080ce64c",
  null
  
)

export default component.exports